export default __webpack_public_path__ + "static/media/China01.cdaaa4d7.obj";